var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PhasesForm',{attrs:{"generate-id-when-create":_vm.generateIdWhenCreate},model:{value:(_vm.phases),callback:function ($$v) {_vm.phases=$$v},expression:"phases"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }